import { Product, WarehouseInventoryDetail } from '@/types/fulfill/inventory';

export const mapWarehouseProducts = (product: Product): WarehouseInventoryDetail[] =>
  (product.warehouse_products ?? []).map((warehouseProduct) => ({
    warehouseId: warehouseProduct.warehouse_id,
    warehouseName: warehouseProduct.warehouse_name,
    physical: warehouseProduct.on_hand,
    available: warehouseProduct.inventory,
    inProcess: warehouseProduct.in_progress,
  }));
